// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ecc10aa9","239":"ca98b241","453":"cba14550","667":"2d9efe6e"}[chunkId] + ".chunk.js";
};